import {
  SETTINGS_VOUCHERS_LIST_ITEM,
  SETTINGS_VOUCHERS_POS_ITEM,
  SETTINGS_VOUCHERS_POS_MATCH_ITEM,
  SETTINGS_VOUCHERS_AFIP_TYPES_ITEM,
  SETTINGS_VOUCHERS_CURRENCIES_ITEM,
} from './settings-vouchers-items.js'

/** @type {import('../help-index.js').HelpScreen} */
export const SETTINGS_VOUCHERS_HELP = {
  screenId: 'settings-vouchers',
  label: 'Comprobantes',
  navPath: 'Configuración → Comprobantes',
  keywords: ['punto de venta', 'pos', 'factura', 'arca', 'afip', 'tipo comprobante'].map((k) => k.toLowerCase()),
  status: 'draft',
  summary: 'Tipos de comprobante, puntos de venta, relaciones POS–tipo, códigos ARCA y monedas por comprobante.',
  sidebarItems: [
    SETTINGS_VOUCHERS_LIST_ITEM,
    SETTINGS_VOUCHERS_POS_ITEM,
    SETTINGS_VOUCHERS_POS_MATCH_ITEM,
    SETTINGS_VOUCHERS_AFIP_TYPES_ITEM,
    SETTINGS_VOUCHERS_CURRENCIES_ITEM,
  ],
}
